import { useRef, useEffect } from 'react';
import defaultTheme from 'e100-react-components/lib/theme/defaultTheme';
import useMediaQuery from 'e100-react-components/lib/hooks/useMediaQuery';

type TTheme = typeof defaultTheme;

type MediaQueryRef = undefined | {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isFullDesktop: boolean;
}

const useHookMediaQuery = () => {
  const mediaQueryRef = useRef<MediaQueryRef>();
  const isMobile = useMediaQuery((theme: TTheme) => (theme.breakpoints.between('xs', 'sm')));
  const isTablet = useMediaQuery((theme: TTheme) => theme.breakpoints.only('md'));
  const isDesktop = useMediaQuery((theme: TTheme) => theme.breakpoints.only('lg'));
  const isFullDesktop = useMediaQuery((theme: TTheme) => theme.breakpoints.up('xl'));

  useEffect(() => {
    mediaQueryRef.current = {
      isMobile,
      isTablet,
      isDesktop,
      isFullDesktop
    }
  }, [isMobile, isTablet, isDesktop, isFullDesktop]);

  return { isMobile, isTablet, isDesktop, isFullDesktop, mediaQueryRef };
};

export default useHookMediaQuery;
